import React from "react";
import { useTranslation } from "react-i18next";

export default function Privacy() {
  const { t } = useTranslation();
  const sections = t("privacy_page.sections", { returnObjects: true }) || [];

  return (
    <div className="max-w-3xl mx-auto px-5 md:px-8 py-16 md:py-24">
      <p className="text-xs uppercase tracking-[0.2em] font-bold text-[#5BA83F]">{t("privacy_page.eyebrow")}</p>
      <h1 className="font-heading text-4xl font-extrabold text-[#1B3A6B] mt-3 tracking-tight">{t("privacy_page.title")}</h1>
      <p className="mt-3 text-xs text-slate-400">{t("privacy_page.last_updated")}: {t("privacy_page.updated_date")}</p>
      <p className="mt-6 text-slate-600 leading-relaxed">{t("privacy_page.intro1")}</p>
      <p className="mt-3 text-slate-600 leading-relaxed">{t("privacy_page.intro2")}</p>

      {sections.map((s, i) => (
        <section key={i} className="mt-10">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-[#0F172A] tracking-tight">{s.title}</h2>
          {s.body && <p className="mt-3 text-slate-600 leading-relaxed whitespace-pre-line">{s.body}</p>}
          {s.bullets && (
            <ul className="mt-3 space-y-1.5">
              {s.bullets.map((b, j) => (
                <li key={j} className="text-slate-600 leading-relaxed pl-5 relative before:content-['•'] before:absolute before:left-0 before:text-[#5BA83F] before:font-bold">{b}</li>
              ))}
            </ul>
          )}
          {s.footer && <p className="mt-3 text-slate-600 leading-relaxed whitespace-pre-line">{s.footer}</p>}
        </section>
      ))}

      <section className="mt-12 bg-slate-50 ring-1 ring-slate-200 rounded-xl p-6">
        <h2 className="font-heading text-lg font-bold text-[#1B3A6B]">{t("privacy_page.contact_title")}</h2>
        <div className="mt-3 text-sm text-slate-600 leading-relaxed space-y-1">
          <div><b>Trustline Schoonmaken</b> (trading as Trustline Services NL)</div>
          <div>Julianastraat 52b, 2405 CJ Alphen aan den Rijn, Netherlands</div>
          <div>Email: info@trustlineservices.nl</div>
          <div>WhatsApp / Phone: +31 6 4244 9019</div>
          <div>KvK: 99642441 · VAT: NL004861783B47</div>
        </div>
      </section>
    </div>
  );
}
